const TASK_TYPES = [
  'onboarding',
  'offboarding',
  'training',
  'document',
  'reviewee',
  'survey',
  'offer',
  'expense',
  'interview_app_setup'
];

export default TASK_TYPES;
